
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/[slug]",
      function () {
        return require("private-next-pages/inspiration/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/[slug]"])
      });
    }
  